import { ErrorToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const HandleGetEventList = async (search_value) => {
  const endpoint = `customer/events?`;
  let queryParam = [];
  if (search_value && search_value.length > 0)
    queryParam.push(`search_value=${search_value}`);
  const eventList = await AxiosGetMethod(
    `${endpoint}${queryParam.join("&")}`
    // `org/events?start_date=2024-11-11&end_date=2025-05-31&search_value=po`
  );
  if (eventList?.status === 200) {
    return eventList.data.data;
  } else {
    if (eventList?.status === 401) HandleLogout();
    ErrorToast("Something went wrong on fetch event list");
    return null;
  }
};

export default HandleGetEventList;
